import { useState } from 'react';
import { PermissionGuard } from '@/features/auth';
import { Button } from '@/shared/components';
import type { DocumentTemplateSummary } from '../types/documentTemplates.types';
import { CustomiseTemplateModal } from './CustomiseTemplateModal';

interface Props {
  template: DocumentTemplateSummary;
  isInternal: boolean;
}

export function TemplateCustomiseAction({ template, isInternal }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  if (template.owner !== 'platform' || !template.published) return null;

  return (
    <PermissionGuard permission={{ resource: 'document_template', action: 'add' }}>
      <Button type="button" size="sm" onClick={() => setIsOpen(true)}>
        {isInternal ? 'Customise for a dealer' : 'Customise for my dealer'}
      </Button>
      {isOpen && <CustomiseTemplateModal source={template} isOpen onClose={() => setIsOpen(false)} />}
    </PermissionGuard>
  );
}
